
import { BrowserRouter } from "react-router-dom";
import TermedCard from "./components/TermedCard";
import Particles from "./components/Particles";

const App = () => {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex items-center justify-center p-4 relative">
        <Particles className="absolute inset-0 -z-10" />
        <TermedCard />
      </div>
    </BrowserRouter>
  );
};

export default App;
